var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<p><a href=\"#\" ng-click=\"$ctrl.showPreviewModal()\" class=\"text-muted\">{{ $ctrl.documentItem.document_type | titlecase }}</a></p>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/common/components/od-document-preview.jade
 ** module id = 696
 ** module chunks = 0 1 3 4 5 6
 **/